export default __webpack_public_path__ + "dabbcf290b85d90a3af3dc01d9fb3631.png";